import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetogoacabs() {



const cardData = {
  keyword: "Pune to Goa Cabs",
  heading: "Lotus Cab: Pune to Goa Cabs",

  headingDescription:
    "Lotus Cabs provides reliable and affordable Pune to Goa Cab Service for beach holidays, family vacations, honeymoon trips, corporate travel, group tours, weekend getaways, and one-way or round-trip journeys. We offer a premium fleet of Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus driven by professional and experienced chauffeurs. With 24x7 booking assistance, transparent pricing, doorstep pickup anywhere in Pune, well-maintained vehicles, and safe highway travel via the scenic Western Ghats, Lotus Cabs ensures a comfortable, enjoyable, and hassle-free journey from Pune to Goa.",


  top: "Top Places to Visit in Goa with Lotus Cab",

topPlaces: [
    {
        title: "Calangute Beach",
        description:
            "Calangute Beach, popularly known as the 'Queen of Beaches,' is one of Goa's most visited tourist destinations. Famous for its golden shoreline, exciting water sports, beach shacks, shopping stalls, and vibrant atmosphere, it attracts families, couples, and groups throughout the year. Travelers booking a Pune to Goa Cab Service with Lotus Cabs often include Calangute as their first stop for a memorable beach holiday."
    },
    {
        title: "Baga Beach",
        description:
            "Baga Beach is one of Goa's most vibrant coastal destinations, renowned for its lively nightlife, beach cafés, seafood restaurants, water sports, and music-filled atmosphere. Visitors enjoy parasailing, jet skiing, dolphin trips, and relaxing by the Arabian Sea, making it a favorite destination for both adventure lovers and leisure travelers."
    },
    {
        title: "Candolim Beach",
        description:
            "Candolim Beach offers a quieter and more relaxed coastal experience compared to North Goa's busier beaches. Known for its clean shoreline, luxury resorts, peaceful ambiance, and thrilling water sports, it is ideal for families, honeymoon couples, and travelers seeking a comfortable seaside escape."
    },
    {
        title: "Fort Aguada",
        description:
            "Fort Aguada is a magnificent 17th-century Portuguese fort overlooking the Arabian Sea. Famous for its historic lighthouse, impressive fortifications, panoramic ocean views, and colonial heritage, it remains one of Goa's most photographed attractions and an essential destination for history enthusiasts."
    },
    {
        title: "Basilica of Bom Jesus",
        description:
            "The Basilica of Bom Jesus is a UNESCO World Heritage Site and one of Goa's most significant religious monuments. Renowned for its Baroque architecture and the preserved relics of St. Francis Xavier, the church attracts pilgrims, history lovers, and international tourists throughout the year."
    },
    {
        title: "Dudhsagar Waterfalls",
        description:
            "Dudhsagar Waterfalls is among India's tallest and most spectacular waterfalls, located amidst the lush forests of the Western Ghats. The cascading white waters, scenic jeep safaris, trekking routes, and breathtaking natural surroundings make it one of the most popular attractions for travelers visiting Goa from Pune."
    },
    {
        title: "Palolem Beach",
        description:
            "Palolem Beach in South Goa is famous for its crescent-shaped coastline, calm waters, palm-lined shores, beach cottages, and peaceful atmosphere. It is an excellent destination for swimming, kayaking, yoga retreats, and relaxing holidays, making it especially popular among couples and families."
    },
    {
        title: "Chapora Fort",
        description:
            "Chapora Fort stands on a hill overlooking Vagator Beach and offers stunning panoramic views of the Arabian Sea and Goa's scenic coastline. Made famous by Bollywood films, the fort attracts visitors interested in photography, sunsets, historical architecture, and breathtaking landscapes."
    },
    {
        title: "Colva Beach",
        description:
            "Colva Beach is one of South Goa's longest and most beautiful beaches, known for its soft white sand, swaying coconut trees, water sports, seafood restaurants, and relaxed coastal charm. It provides a perfect setting for families and travelers looking to enjoy a peaceful beach vacation away from crowded tourist spots."
    },
    {
        title: "Anjuna Beach",
        description:
            "Anjuna Beach is famous for its dramatic rocky coastline, vibrant flea market, beach cafés, nightlife, and spectacular sunset views. A favorite among domestic and international travelers, it combines Goa's bohemian culture with adventure activities and scenic beauty, making it an essential destination on every Goa itinerary."
    }
],

  services: [
    {
      name: "Pune to Goa Taxi Service",
      description:
        "Reliable Pune to Goa taxi service with professional drivers and well-maintained vehicles. Comfortable sedan and SUV options available. Transparent per-km pricing ensured. Safe ghat and highway travel experience. Ideal for family and corporate trips. 24/7 booking support provided."
    },
    {
      name: "Pune to Goa One Way Cab",
      description:
        "Affordable one-way cab from Pune to Goa with clear billing structure. Pay only for single-side distance. Ideal for drop services and relocation travel. Timely pickup from Pune. Comfortable and sanitized vehicles available. Hassle-free booking guaranteed."
    },
    {
      name: "Pune to Goa Round Trip Taxi",
      description:
        "Flexible round-trip taxi service for Pune to Goa travel. Suitable for weekend and extended stays. Transparent fare breakdown provided. Spacious vehicles available for families. Professional highway drivers ensured. Stress-free return journey supported."
    },
    {
      name: "Luxury Cab Pune to Goa",
      description:
        "Premium luxury cab service for executive and honeymoon travel. High-end vehicles available for extra comfort. Spacious seating and smooth ride ensured. Experienced chauffeurs provided. Ideal for special occasions. Premium travel experience guaranteed."
    },
    {
      name: "SUV Taxi Pune to Goa",
      description:
        "Spacious SUV taxis ideal for group and family travel. Extra luggage space available. Comfortable seating for long-distance ride. Smooth highway performance ensured. Suitable for beach vacations. Safe and reliable journey guaranteed."
    },
    {
      name: "Sedan Cab Pune to Goa",
      description:
        "Comfortable sedan cab options for individuals and couples. Budget-friendly pricing available. Air-conditioned vehicles provided. Professional drivers ensure safety. Ideal for long-distance travel. Reliable and punctual service guaranteed."
    },
    {
      name: "Overnight Cab Pune to Goa",
      description:
        "Overnight cab service for flexible travel scheduling. Safe night highway driving ensured. Experienced chauffeurs available. Comfortable long-distance travel supported. Ideal for early morning beach arrival. Reliable 24/7 service available."
    },
    {
      name: "Online Cab Booking Pune to Goa",
      description:
        "Easy online cab booking with instant confirmation. Secure payment options available. Flexible pickup scheduling supported. Transparent pricing shared before confirmation. 24/7 customer support available. Convenient and stress-free booking process."
    }
  ],

  tableData: [
    ["Pune to Goa Cabs", "Pune to Goa Taxi Service"],
    ["Pune to Goa One Way Cab", "Pune to Goa Round Trip Taxi"],
    ["Pune to Goa Outstation Cab", "Affordable Pune to Goa Cab"],
    ["Luxury Cab Pune to Goa", "SUV Taxi Pune to Goa"],
    ["Sedan Cab Pune to Goa", "Cheap Pune to Goa Taxi"],
    ["Online Cab Booking Pune to Goa", "Pune to North Goa Cab"],
    ["Pune to South Goa Taxi", "Pune to Calangute Cab"],
    ["Pune to Baga Beach Taxi", "Family Trip Cab Pune to Goa"],
    ["Corporate Taxi Pune to Goa", "Overnight Cab Pune to Goa"],
    ["Pune to Goa Drop Taxi", "Best Cab Service Pune to Goa"]
  ],

  whychoose: [
    {
      WhyChooseheading: "Safe Coastal Travel",
      WhyChoosedescription:
        "Experienced drivers skilled in ghat and coastal highway routes ensure safe long-distance travel."
    },
    {
      WhyChooseheading: "Transparent Per KM Pricing",
      WhyChoosedescription:
        "Clear fare structure with no hidden charges and complete billing transparency."
    },
    {
      WhyChooseheading: "One-Way & Round Trip Options",
      WhyChoosedescription:
        "Flexible one-way and return trip options available based on your schedule."
    },
    {
      WhyChooseheading: "Well-Maintained Vehicles",
      WhyChoosedescription:
        "Clean, sanitized, and regularly serviced sedan and SUV fleet."
    },
    {
      WhyChooseheading: "24/7 Booking Support",
      WhyChoosedescription:
        "Round-the-clock customer support for booking and travel coordination."
    },
    {
      WhyChooseheading: "Luxury & Budget Options",
      WhyChoosedescription:
        "Choose between affordable or premium vehicle categories."
    },
    {
      WhyChooseheading: "Family & Corporate Friendly",
      WhyChoosedescription:
        "Ideal for family vacations, corporate trips, and group outings."
    },
    {
      WhyChooseheading: "Comfortable Long-Distance Ride",
      WhyChoosedescription:
        "Spacious seating and smooth highway performance for stress-free travel."
    }
  ]
};

const faqData = [
  { question: "How long does Pune to Goa taxi take?", answer: "The journey typically takes 8 to 10 hours depending on traffic and route conditions." },
  { question: "Is one-way service available?", answer: "Yes, one-way drop service is available with transparent pricing." },
  { question: "Are toll charges included?", answer: "Toll and parking charges are generally billed separately and clearly informed before booking." },
  { question: "Do you provide SUV options?", answer: "Yes, SUV taxis are available for family and group travel." },
  { question: "Is night travel available?", answer: "Yes, overnight cab service is available for flexible travel plans." },
  { question: "Can I book for North or South Goa?", answer: "Yes, drop services are available for North Goa and South Goa destinations." },
  { question: "Are vehicles sanitized?", answer: "Yes, vehicles are cleaned and sanitized before every trip." },
  { question: "Is online booking available?", answer: "Yes, online booking with instant confirmation is available." },
  { question: "Do you provide corporate cab service?", answer: "Yes, corporate and executive travel options are available." },
  { question: "Can I book round-trip service?", answer: "Yes, round-trip cab service is available with flexible return scheduling." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Anil Deshpande",
    feedback:
      "Booked Pune to Goa cab for our family vacation. The SUV was spacious and comfortable. Driver was professional and punctual. Very smooth highway journey.",
    rating: 5
  },
  {
    id: 2,
    name: "Ms. Riya Mehta",
    feedback:
      "Our one-way trip to Goa was perfectly managed. Transparent pricing and clean vehicle made it stress-free. Highly recommend Lotus Cab.",
    rating: 5
  },
  {
    id: 3,
    name: "Mr. Vivek Sharma",
    feedback:
      "Corporate trip to Goa was handled professionally. On-time pickup and fair pricing impressed us. Will book again for future travel.",
    rating: 5
  }
];





























































































const Images = [
  { place: "/images/keyword/1.jpg", text: "Pune Taxi Fare", link: "Pune-Taxi-Fare" },
  { place: "/images/keyword/2.jpg", text: "Pune Outstation Taxi Hire", link: "Pune-Outstation-Taxi-Hire" },
  { place: "/images/keyword/3.jpg", text: "Pimpri Chinchwad Online Cab", link: "Pimpri-Chinchwad-Online-Cab" },
  { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
  { place: "/images/keyword/5.jpg", text: "Pune to Mumbai One Way Cabs", link: "Pune-to-Mumbai-One-Way-Cabs" },
  { place: "/images/keyword/6.jpg", text: "Pune to Nasik Cabs", link: "Pune-to-Nasik-Cabs" },
  { place: "/images/keyword/7.jpg", text: "Pune to Mahabaleshwar Cabs", link: "Pune-to-Mahabaleshwar-Cabs" },
  { place: "/images/keyword/8.jpg", text: "Pune to Lonavala Cab Booking", link: "Pune-to-Lonavala-Cab-Booking" },
  { place: "/images/keyword/9.jpg", text: "Pune to Shirdi Cabs", link: "Pune-to-Shirdi-Cabs" },
  { place: "/images/keyword/10.jpg", text: "Pune to Lavasa City Cabs", link: "Pune-to-Lavasa-City-Cabs" },
  { place: "/images/keyword/11.jpg", text: "Pune Airport to Bhimashankar Cabs", link: "Pune-Airport-to-Bhimashankar-Cabs" },
  { place: "/images/keyword/12.jpg", text: "Pune to Indore Cabs", link: "Pune-to-Indore-Cabs" },
  { place: "/images/keyword/13.jpg", text: "Pune to Konkan Darshan Cabs", link: "Pune-to-Konkan-Darshan-Cabs" },
  { place: "/images/keyword/14.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
  { place: "/images/keyword/15.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
  { place: "/images/keyword/16.jpg", text: "Pune to Panchgani Cab Booking", link: "Pune-to-Panchgani-Cab-Booking" },
  { place: "/images/keyword/17.jpg", text: "Pune to Mumbai International Airport Taxi", link: "Pune-to-Mumbai-International-Airport-Taxi" },
  { place: "/images/keyword/18.jpg", text: "Ashtavinayak Darshan Cab Package", link: "Ashtavinayak-Darshan-Cab-Package" },
  { place: "/images/keyword/19.jpg", text: "Pune To Nagpur Cabs", link: "Pune-To-Nagpur-Cabs" },
  { place: "/images/keyword/20.jpg", text: "Cab Service in Kharadi", link: "Cab-Service-in-Kharadi" },
  { place: "/images/keyword/21.jpg", text: "Taxi Service in Hinjewadi Pune", link: "Taxi-Service-in-Hinjewadi-Pune" },
  { place: "/images/keyword/22.jpg", text: "Pune to Gujarat Cab Service", link: "Pune-to-Gujarat-Cab-Service" },
  { place: "/images/keyword/23.jpg", text: "Travel Agents in Pune", link: "Travel-Agents-in-Pune" },
  { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
  { place: "/images/keyword/25.jpg", text: "Pune to Bangalore Taxi Service", link: "Pune-to-Bangalore-Taxi-Service" },

];








const productSchema = {
"@context": "https://schema.org",
"@type": "Product",
"name": "Pune to Goa Cab Service",
"image": "https://lotuscab.com/assets/images/pune-to-goa-cab-service.jpg",
"description": "Book Pune to Goa Cab Service with Lotus Cab for safe, comfortable, and affordable long-distance travel. One way and round trip taxi service with Sedan, SUV, and AC cabs available 24x7 with professional drivers and instant booking confirmation.",
"brand": {
"@type": "Brand",
"name": "Lotus Cab"
},
"aggregateRating": {
"@type": "AggregateRating",
"bestRating": "5",
"worstRating": "1",
"ratingValue": "4.8",
"ratingCount": "7186"
},
"offers": {
"@type": "Offer",
"priceCurrency": "INR",
"price": "Starting From ₹11/Km",
"availability": "https://schema.org/InStock",
"url": "https://lotuscab.com/pune-to-goa-cab-service"
}
};










  return (
    <div>
      
<Helmet>
  <title>Pune to Goa Cab Service | One Way & Round Trip Taxi | +91 8767592195</title>

<meta
 name="description"
 content="Book Pune to Goa Cab Service with Lotus Cab at affordable fares. One way and round trip taxi service with Sedan, SUV, and AC cabs, experienced drivers, 24x7 support, and instant booking confirmation for a comfortable coastal journey."
/>

<meta
 name="keywords"
 content="Pune to Goa Cab Service, Pune to Goa Cab, Pune to Goa Taxi, Pune to Goa Taxi Service, Goa Cab from Pune, One Way Cab Pune to Goa, Round Trip Cab Pune to Goa, Outstation Cab Pune to Goa, Pune to Goa Road Trip Cab, Affordable Pune to Goa Cab, Cheap Pune to Goa Taxi, Online Pune to Goa Cab Booking, Sedan Cab Pune to Goa, SUV Cab Pune to Goa, Best Pune to Goa Cab, Lotus Cab Pune"
/>

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>

</Helmet>




 <section className="page-header">
      
      {/* Background Image */}
      <div
        className="page-header__bg"
        style={{
          backgroundImage:
            "url(../images/page-header-bg-1-1.jpg)",
        }}
      ></div>
      <div className="container">
        <div className="page-header__content">
        
          <h2 className="page-header__title"> {cardData.keyword}</h2>
        </div>
      </div>
    </section>


      








      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/26.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>
              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    <div className="service-icon">
                      🚖
                    </div>
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Lotus Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Lotus Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+918767592195" className="pc-call">+91 8767592195</a>
                      <a href="tel:+919172145909" className="pc-call">+91 9172145909</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/918767592195"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+918767592195" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@lotuscab.com" className="pc-email">
                      booking@lotuscab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Lotus Cab </strong><br />
                    Mauli Krupa building,
                    Sant Tukaram Nagar Gali No.1,
                    Navi sangvi MK chauk -411027
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetogoacabs;